/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown>, comment: NonNullable<unknown> }} Timeline_Marker_Aria_LabelInputs */

const en_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marker at ${i?.timecode} - ${i?.comment}`)
};

const fr_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marqueur a ${i?.timecode} - ${i?.comment}`)
};

const de_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Markierung bei ${i?.timecode} - ${i?.comment}`)
};

const it_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marcatore a ${i?.timecode} - ${i?.comment}`)
};

const ru_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Маркер на ${i?.timecode} - ${i?.comment}`)
};

const es_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marcador en ${i?.timecode} - ${i?.comment}`)
};

const zh_cn2_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`标记点位于 ${i?.timecode} - ${i?.comment}`)
};

const ja_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.timecode} - ${i?.comment} のマーカー`)
};

const hi_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मार्कर ${i?.timecode} - ${i?.comment} पर`)
};

const pt_pt2_timeline_marker_aria_label = /** @type {(inputs: Timeline_Marker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marcador em ${i?.timecode} - ${i?.comment}`)
};

/**
* | output |
* | --- |
* | "Marker at {timecode} - {comment}" |
*
* @param {Timeline_Marker_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_marker_aria_label = /** @type {((inputs: Timeline_Marker_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Marker_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_marker_aria_label(inputs)
	if (locale === "de") return de_timeline_marker_aria_label(inputs)
	if (locale === "it") return it_timeline_marker_aria_label(inputs)
	if (locale === "ru") return ru_timeline_marker_aria_label(inputs)
	if (locale === "es") return es_timeline_marker_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_marker_aria_label(inputs)
	if (locale === "ja") return ja_timeline_marker_aria_label(inputs)
	if (locale === "hi") return hi_timeline_marker_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_marker_aria_label(inputs)
	return en_timeline_marker_aria_label(inputs)
});